import React from 'react';

import { StatusBadgeProps } from './StatusBadge.props';
import { TablePill, toneForStatus } from '../TablePill';

/**
 * A status, wherever one is shown outside a list table — detail panels, summary
 * bars, the preview drawer, the confirm dialogs, mobile.
 *
 * It is a thin adapter over `TablePill` rather than its own thing: a status
 * looked different on the Jobs list than it did on the job itself, and the two
 * palettes had drifted far enough apart that neither could be adjusted without
 * making the gap worse. Its `size` prop is kept so the seventeen call sites did
 * not all have to change at once, but everything that decides how it looks now
 * lives in one place.
 */
export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'default' }) => (
  <TablePill
    tone={toneForStatus(status)}
    size={size === 'small' ? 'sm' : 'md'}
    ariaLabel={`Status: ${status}`}
  >
    {status}
  </TablePill>
);
